/**
 * Konto kasutus-näitajad - kõik kasutaja hallatavad saidid + iga saidi näitajad
 * (`GET /api/account/usage`, KASUTAJA-skoobitud, X-Site-Id pole vaja). Vastab
 * backend'i `modules/usage/usage.service.ts` + `/api/account/usage` kujule.
 */
import { api } from "./api";

export interface UsageMetric {
  unlimited: boolean;
  limit: number;
  used: number;
  remaining: number | null;
  ratio: number;
  warn: boolean;
  exceeded: boolean;
}

export interface StorageUsage extends UsageMetric {
  usedBytes: number;
  limitMb: number;
}

export interface SiteUsageRow {
  siteId: string;
  name: string;
  accountId: string | null;
  /** Konto sites.max kvoot (õesaidid jagavad). limit -1 = ∞. */
  quota: { used: number; limit: number } | null;
  planCode: string;
  storage: StorageUsage;
  pages: UsageMetric;
  media: { count: number };
  locales: UsageMetric;
  /** Teksti-krediidid (pilt/video välistatud - neil on tükikvoodid all). */
  ai: UsageMetric;
  aiImages: UsageMetric;
  aiVideos: UsageMetric;
}

export interface AccountUsage {
  sites: SiteUsageRow[];
}

export const usage = {
  account: () => api.get<AccountUsage>("/account/usage"),
};
